// extracted by mini-css-extract-plugin
export default {"bca":"Style_bca__sqz9x","education":"Style_education__n8Xja","skills":"Style_skills__-98Ij","topres":"Style_topres__4jRci","edubox":"Style_edubox__W1jtx"};